import { membersApi } from '../api/membersApi'
import type { MemberCreateInput } from '../types/member'

export const addMember = async (member: MemberCreateInput) => {
  try {
    const { data } = await membersApi.createMember(member)
    return data
  } catch (error) {
    console.error(`Error creating member: `, error)
    throw error
  }
}
